/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/files/v1/api.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  ApiHttpBody,
  ApiHttpBodyBody,
  DeleteFile200,
  DeleteFile2200,
  DownloadFileStream200,
  FilesServiceGenerateDownloadUrlBodyBody,
  FilesServiceGenerateUploadUrlBodyBody,
  PaginateValueContentParams,
  RpcStatus,
  V1CopyFileRequest,
  V1CopyFileResponse,
  V1DownloadFileStreamRequest,
  V1FileMetadata,
  V1GenerateDownloadUrlResponse,
  V1GenerateUploadUrlResponse,
  V1PaginateValueContentResponse,
  V1ReplaceFileContentResponse,
  V1UploadFileResponse,
  V1UploadFileStreamRequest,
  V1UploadFileStreamResponse,
} from '../../models';

/**
 * @summary Delete file
 */
export const deleteFile = (
  organization: string,
  file: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteFile200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/files/${file}`,
    options,
  );
};

export const getDeleteFileMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { organization: string; file: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { organization: string; file: string },
  TContext
> => {
  const mutationKey = ['deleteFile'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFile>>,
    { organization: string; file: string }
  > = props => {
    const { organization, file } = props ?? {};

    return deleteFile(organization, file, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFile>>
>;

export type DeleteFileMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete file
 */
export const useDeleteFile = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFile>>,
      TError,
      { organization: string; file: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { organization: string; file: string },
  TContext
> => {
  const mutationOptions = getDeleteFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get file metadata only
 */
export const getFileMetadata = (
  organization: string,
  file: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1FileMetadata>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/files/${file}/metadata`,
    options,
  );
};

export const getGetFileMetadataQueryKey = (
  organization?: string,
  file?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/files/${file}/metadata`,
  ] as const;
};

export const getGetFileMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof getFileMetadata>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFileMetadataQueryKey(organization, file);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileMetadata>>> = ({
    signal,
  }) => getFileMetadata(organization, file, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && file),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFileMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFileMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFileMetadata>>
>;
export type GetFileMetadataQueryError = AxiosError<RpcStatus>;

export function useGetFileMetadata<
  TData = Awaited<ReturnType<typeof getFileMetadata>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileMetadata>>,
          TError,
          Awaited<ReturnType<typeof getFileMetadata>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFileMetadata<
  TData = Awaited<ReturnType<typeof getFileMetadata>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileMetadata>>,
          TError,
          Awaited<ReturnType<typeof getFileMetadata>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFileMetadata<
  TData = Awaited<ReturnType<typeof getFileMetadata>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get file metadata only
 */

export function useGetFileMetadata<
  TData = Awaited<ReturnType<typeof getFileMetadata>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFileMetadataQueryOptions(
    organization,
    file,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download file content
Direct REST Implementation:
- Binary response with metadata in HTTP headers
 */
export const downloadFile = (
  organization: string,
  file: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/files/${file}:download`,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getDownloadFileQueryKey = (
  organization?: string,
  file?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/files/${file}:download`,
  ] as const;
};

export const getDownloadFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadFileQueryKey(organization, file);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile>>> = ({
    signal,
  }) => downloadFile(organization, file, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && file),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadFile>>
>;
export type DownloadFileQueryError = AxiosError<RpcStatus>;

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download file content
Direct REST Implementation:
- Binary response with metadata in HTTP headers
 */

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadFileQueryOptions(organization, file, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generate presigned URL for direct download
 */
export const generateDownloadUrl = (
  organization: string,
  file: string,
  filesServiceGenerateDownloadUrlBodyBody: FilesServiceGenerateDownloadUrlBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GenerateDownloadUrlResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/files/${file}:generateDownloadUrl`,
    filesServiceGenerateDownloadUrlBodyBody,
    options,
  );
};

export const getGenerateDownloadUrlMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDownloadUrl>>,
    TError,
    {
      organization: string;
      file: string;
      data: FilesServiceGenerateDownloadUrlBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDownloadUrl>>,
  TError,
  {
    organization: string;
    file: string;
    data: FilesServiceGenerateDownloadUrlBodyBody;
  },
  TContext
> => {
  const mutationKey = ['generateDownloadUrl'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDownloadUrl>>,
    {
      organization: string;
      file: string;
      data: FilesServiceGenerateDownloadUrlBodyBody;
    }
  > = props => {
    const { organization, file, data } = props ?? {};

    return generateDownloadUrl(organization, file, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDownloadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDownloadUrl>>
>;
export type GenerateDownloadUrlMutationBody =
  FilesServiceGenerateDownloadUrlBodyBody;
export type GenerateDownloadUrlMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generate presigned URL for direct download
 */
export const useGenerateDownloadUrl = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateDownloadUrl>>,
      TError,
      {
        organization: string;
        file: string;
        data: FilesServiceGenerateDownloadUrlBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateDownloadUrl>>,
  TError,
  {
    organization: string;
    file: string;
    data: FilesServiceGenerateDownloadUrlBodyBody;
  },
  TContext
> => {
  const mutationOptions = getGenerateDownloadUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generate presigned URL for direct upload
 */
export const generateUploadUrl = (
  organization: string,
  filesServiceGenerateUploadUrlBodyBody: FilesServiceGenerateUploadUrlBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GenerateUploadUrlResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/files:generateUploadUrl`,
    filesServiceGenerateUploadUrlBodyBody,
    options,
  );
};

export const getGenerateUploadUrlMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadUrl>>,
    TError,
    { organization: string; data: FilesServiceGenerateUploadUrlBodyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateUploadUrl>>,
  TError,
  { organization: string; data: FilesServiceGenerateUploadUrlBodyBody },
  TContext
> => {
  const mutationKey = ['generateUploadUrl'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateUploadUrl>>,
    { organization: string; data: FilesServiceGenerateUploadUrlBodyBody }
  > = props => {
    const { organization, data } = props ?? {};

    return generateUploadUrl(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateUploadUrl>>
>;
export type GenerateUploadUrlMutationBody =
  FilesServiceGenerateUploadUrlBodyBody;
export type GenerateUploadUrlMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generate presigned URL for direct upload
 */
export const useGenerateUploadUrl = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateUploadUrl>>,
      TError,
      { organization: string; data: FilesServiceGenerateUploadUrlBodyBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateUploadUrl>>,
  TError,
  { organization: string; data: FilesServiceGenerateUploadUrlBodyBody },
  TContext
> => {
  const mutationOptions = getGenerateUploadUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The lifetime of the file is the lifetime of the organization, ie,
if the organization is deleted, its file will also be deleted.
 * @summary Upload file content
Direct REST Implementation:
- multipart/form-data with filename and file fields
- Returns complete FileMetadata with server-generated fields
 */
export const uploadFile = (
  organization: string,
  apiHttpBodyBody: ApiHttpBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UploadFileResponse | unknown>> => {
  const formData = new FormData();
  if (apiHttpBodyBody.content_type !== undefined) {
    formData.append(`content_type`, apiHttpBodyBody.content_type);
  }
  if (apiHttpBodyBody.data !== undefined) {
    formData.append(`data`, apiHttpBodyBody.data);
  }
  if (apiHttpBodyBody.extensions !== undefined) {
    apiHttpBodyBody.extensions.forEach(value =>
      formData.append(`extensions`, JSON.stringify(value)),
    );
  }

  return axios.default.post(
    `/api/v1/organizations/${organization}/files:upload`,
    formData,
    options,
  );
};

export const getUploadFileMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { organization: string; data: ApiHttpBodyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { organization: string; data: ApiHttpBodyBody },
  TContext
> => {
  const mutationKey = ['uploadFile'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile>>,
    { organization: string; data: ApiHttpBodyBody }
  > = props => {
    const { organization, data } = props ?? {};

    return uploadFile(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFile>>
>;
export type UploadFileMutationBody = ApiHttpBodyBody;
export type UploadFileMutationError = AxiosError<RpcStatus>;

/**
 * @summary Upload file content
Direct REST Implementation:
- multipart/form-data with filename and file fields
- Returns complete FileMetadata with server-generated fields
 */
export const useUploadFile = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFile>>,
      TError,
      { organization: string; data: ApiHttpBodyBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { organization: string; data: ApiHttpBodyBody },
  TContext
> => {
  const mutationOptions = getUploadFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete file
 */
export const deleteFile2 = (
  organization: string,
  workspace: string,
  file: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteFile2200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}`,
    options,
  );
};

export const getDeleteFile2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile2>>,
    TError,
    { organization: string; workspace: string; file: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFile2>>,
  TError,
  { organization: string; workspace: string; file: string },
  TContext
> => {
  const mutationKey = ['deleteFile2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFile2>>,
    { organization: string; workspace: string; file: string }
  > = props => {
    const { organization, workspace, file } = props ?? {};

    return deleteFile2(organization, workspace, file, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFile2MutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFile2>>
>;

export type DeleteFile2MutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete file
 */
export const useDeleteFile2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFile2>>,
      TError,
      { organization: string; workspace: string; file: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFile2>>,
  TError,
  { organization: string; workspace: string; file: string },
  TContext
> => {
  const mutationOptions = getDeleteFile2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get file metadata only
 */
export const getFileMetadata2 = (
  organization: string,
  workspace: string,
  file: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1FileMetadata>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}/metadata`,
    options,
  );
};

export const getGetFileMetadata2QueryKey = (
  organization?: string,
  workspace?: string,
  file?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}/metadata`,
  ] as const;
};

export const getGetFileMetadata2QueryOptions = <
  TData = Awaited<ReturnType<typeof getFileMetadata2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFileMetadata2QueryKey(organization, workspace, file);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFileMetadata2>>
  > = ({ signal }) =>
    getFileMetadata2(organization, workspace, file, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && file),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFileMetadata2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFileMetadata2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getFileMetadata2>>
>;
export type GetFileMetadata2QueryError = AxiosError<RpcStatus>;

export function useGetFileMetadata2<
  TData = Awaited<ReturnType<typeof getFileMetadata2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileMetadata2>>,
          TError,
          Awaited<ReturnType<typeof getFileMetadata2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFileMetadata2<
  TData = Awaited<ReturnType<typeof getFileMetadata2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileMetadata2>>,
          TError,
          Awaited<ReturnType<typeof getFileMetadata2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFileMetadata2<
  TData = Awaited<ReturnType<typeof getFileMetadata2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get file metadata only
 */

export function useGetFileMetadata2<
  TData = Awaited<ReturnType<typeof getFileMetadata2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileMetadata2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFileMetadata2QueryOptions(
    organization,
    workspace,
    file,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download file content
Direct REST Implementation:
- Binary response with metadata in HTTP headers
 */
export const downloadFile2 = (
  organization: string,
  workspace: string,
  file: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}:download`,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getDownloadFile2QueryKey = (
  organization?: string,
  workspace?: string,
  file?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}:download`,
  ] as const;
};

export const getDownloadFile2QueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFile2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadFile2QueryKey(organization, workspace, file);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile2>>> = ({
    signal,
  }) =>
    downloadFile2(organization, workspace, file, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && file),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadFile2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadFile2QueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadFile2>>
>;
export type DownloadFile2QueryError = AxiosError<RpcStatus>;

export function useDownloadFile2<
  TData = Awaited<ReturnType<typeof downloadFile2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile2>>,
          TError,
          Awaited<ReturnType<typeof downloadFile2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile2<
  TData = Awaited<ReturnType<typeof downloadFile2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile2>>,
          TError,
          Awaited<ReturnType<typeof downloadFile2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile2<
  TData = Awaited<ReturnType<typeof downloadFile2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download file content
Direct REST Implementation:
- Binary response with metadata in HTTP headers
 */

export function useDownloadFile2<
  TData = Awaited<ReturnType<typeof downloadFile2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadFile2QueryOptions(
    organization,
    workspace,
    file,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generate presigned URL for direct download
 */
export const generateDownloadUrl2 = (
  organization: string,
  workspace: string,
  file: string,
  filesServiceGenerateDownloadUrlBodyBody: FilesServiceGenerateDownloadUrlBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GenerateDownloadUrlResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}:generateDownloadUrl`,
    filesServiceGenerateDownloadUrlBodyBody,
    options,
  );
};

export const getGenerateDownloadUrl2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDownloadUrl2>>,
    TError,
    {
      organization: string;
      workspace: string;
      file: string;
      data: FilesServiceGenerateDownloadUrlBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDownloadUrl2>>,
  TError,
  {
    organization: string;
    workspace: string;
    file: string;
    data: FilesServiceGenerateDownloadUrlBodyBody;
  },
  TContext
> => {
  const mutationKey = ['generateDownloadUrl2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDownloadUrl2>>,
    {
      organization: string;
      workspace: string;
      file: string;
      data: FilesServiceGenerateDownloadUrlBodyBody;
    }
  > = props => {
    const { organization, workspace, file, data } = props ?? {};

    return generateDownloadUrl2(
      organization,
      workspace,
      file,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDownloadUrl2MutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDownloadUrl2>>
>;
export type GenerateDownloadUrl2MutationBody =
  FilesServiceGenerateDownloadUrlBodyBody;
export type GenerateDownloadUrl2MutationError = AxiosError<RpcStatus>;

/**
 * @summary Generate presigned URL for direct download
 */
export const useGenerateDownloadUrl2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateDownloadUrl2>>,
      TError,
      {
        organization: string;
        workspace: string;
        file: string;
        data: FilesServiceGenerateDownloadUrlBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateDownloadUrl2>>,
  TError,
  {
    organization: string;
    workspace: string;
    file: string;
    data: FilesServiceGenerateDownloadUrlBodyBody;
  },
  TContext
> => {
  const mutationOptions = getGenerateDownloadUrl2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Paginate content from an offloaded value file.
 */
export const paginateValueContent = (
  organization: string,
  workspace: string,
  file: string,
  params: PaginateValueContentParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PaginateValueContentResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}:paginateValueContent`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getPaginateValueContentQueryKey = (
  organization?: string,
  workspace?: string,
  file?: string,
  params?: PaginateValueContentParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}:paginateValueContent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPaginateValueContentQueryOptions = <
  TData = Awaited<ReturnType<typeof paginateValueContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  params: PaginateValueContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof paginateValueContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPaginateValueContentQueryKey(organization, workspace, file, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof paginateValueContent>>
  > = ({ signal }) =>
    paginateValueContent(organization, workspace, file, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && file),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof paginateValueContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PaginateValueContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof paginateValueContent>>
>;
export type PaginateValueContentQueryError = AxiosError<RpcStatus>;

export function usePaginateValueContent<
  TData = Awaited<ReturnType<typeof paginateValueContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  params: PaginateValueContentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof paginateValueContent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paginateValueContent>>,
          TError,
          Awaited<ReturnType<typeof paginateValueContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePaginateValueContent<
  TData = Awaited<ReturnType<typeof paginateValueContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  params: PaginateValueContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof paginateValueContent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paginateValueContent>>,
          TError,
          Awaited<ReturnType<typeof paginateValueContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePaginateValueContent<
  TData = Awaited<ReturnType<typeof paginateValueContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  params: PaginateValueContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof paginateValueContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Paginate content from an offloaded value file.
 */

export function usePaginateValueContent<
  TData = Awaited<ReturnType<typeof paginateValueContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  file: string,
  params: PaginateValueContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof paginateValueContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPaginateValueContentQueryOptions(
    organization,
    workspace,
    file,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Replace an existing file's content, preserving its identity.
The resource name and create_time are unchanged, so existing references
to the file stay valid.
Direct REST Implementation:
- multipart/form-data with a single content field
- Returns the updated FileMetadata
 */
export const replaceFileContent = (
  organization: string,
  workspace: string,
  file: string,
  apiHttpBody: ApiHttpBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ReplaceFileContentResponse>> => {
  const formData = new FormData();
  if (apiHttpBody.content_type !== undefined) {
    formData.append(`content_type`, apiHttpBody.content_type);
  }
  if (apiHttpBody.data !== undefined) {
    formData.append(`data`, apiHttpBody.data);
  }
  if (apiHttpBody.extensions !== undefined) {
    apiHttpBody.extensions.forEach(value =>
      formData.append(`extensions`, JSON.stringify(value)),
    );
  }

  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files/${file}:replaceContent`,
    formData,
    options,
  );
};

export const getReplaceFileContentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceFileContent>>,
    TError,
    {
      organization: string;
      workspace: string;
      file: string;
      data: ApiHttpBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceFileContent>>,
  TError,
  { organization: string; workspace: string; file: string; data: ApiHttpBody },
  TContext
> => {
  const mutationKey = ['replaceFileContent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceFileContent>>,
    { organization: string; workspace: string; file: string; data: ApiHttpBody }
  > = props => {
    const { organization, workspace, file, data } = props ?? {};

    return replaceFileContent(
      organization,
      workspace,
      file,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceFileContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceFileContent>>
>;
export type ReplaceFileContentMutationBody = ApiHttpBody;
export type ReplaceFileContentMutationError = AxiosError<RpcStatus>;

/**
 * @summary Replace an existing file's content, preserving its identity.
The resource name and create_time are unchanged, so existing references
to the file stay valid.
Direct REST Implementation:
- multipart/form-data with a single content field
- Returns the updated FileMetadata
 */
export const useReplaceFileContent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof replaceFileContent>>,
      TError,
      {
        organization: string;
        workspace: string;
        file: string;
        data: ApiHttpBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof replaceFileContent>>,
  TError,
  { organization: string; workspace: string; file: string; data: ApiHttpBody },
  TContext
> => {
  const mutationOptions = getReplaceFileContentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generate presigned URL for direct upload
 */
export const generateUploadUrl2 = (
  organization: string,
  workspace: string,
  filesServiceGenerateUploadUrlBodyBody: FilesServiceGenerateUploadUrlBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GenerateUploadUrlResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files:generateUploadUrl`,
    filesServiceGenerateUploadUrlBodyBody,
    options,
  );
};

export const getGenerateUploadUrl2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadUrl2>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: FilesServiceGenerateUploadUrlBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateUploadUrl2>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: FilesServiceGenerateUploadUrlBodyBody;
  },
  TContext
> => {
  const mutationKey = ['generateUploadUrl2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateUploadUrl2>>,
    {
      organization: string;
      workspace: string;
      data: FilesServiceGenerateUploadUrlBodyBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return generateUploadUrl2(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateUploadUrl2MutationResult = NonNullable<
  Awaited<ReturnType<typeof generateUploadUrl2>>
>;
export type GenerateUploadUrl2MutationBody =
  FilesServiceGenerateUploadUrlBodyBody;
export type GenerateUploadUrl2MutationError = AxiosError<RpcStatus>;

/**
 * @summary Generate presigned URL for direct upload
 */
export const useGenerateUploadUrl2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateUploadUrl2>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: FilesServiceGenerateUploadUrlBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateUploadUrl2>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: FilesServiceGenerateUploadUrlBodyBody;
  },
  TContext
> => {
  const mutationOptions = getGenerateUploadUrl2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The lifetime of the file is the lifetime of the organization, ie,
if the organization is deleted, its file will also be deleted.
 * @summary Upload file content
Direct REST Implementation:
- multipart/form-data with filename and file fields
- Returns complete FileMetadata with server-generated fields
 */
export const uploadFile2 = (
  organization: string,
  workspace: string,
  apiHttpBodyBody: ApiHttpBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UploadFileResponse | unknown>> => {
  const formData = new FormData();
  if (apiHttpBodyBody.content_type !== undefined) {
    formData.append(`content_type`, apiHttpBodyBody.content_type);
  }
  if (apiHttpBodyBody.data !== undefined) {
    formData.append(`data`, apiHttpBodyBody.data);
  }
  if (apiHttpBodyBody.extensions !== undefined) {
    apiHttpBodyBody.extensions.forEach(value =>
      formData.append(`extensions`, JSON.stringify(value)),
    );
  }

  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/files:upload`,
    formData,
    options,
  );
};

export const getUploadFile2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile2>>,
    TError,
    { organization: string; workspace: string; data: ApiHttpBodyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile2>>,
  TError,
  { organization: string; workspace: string; data: ApiHttpBodyBody },
  TContext
> => {
  const mutationKey = ['uploadFile2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile2>>,
    { organization: string; workspace: string; data: ApiHttpBodyBody }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return uploadFile2(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFile2MutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFile2>>
>;
export type UploadFile2MutationBody = ApiHttpBodyBody;
export type UploadFile2MutationError = AxiosError<RpcStatus>;

/**
 * @summary Upload file content
Direct REST Implementation:
- multipart/form-data with filename and file fields
- Returns complete FileMetadata with server-generated fields
 */
export const useUploadFile2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFile2>>,
      TError,
      { organization: string; workspace: string; data: ApiHttpBodyBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile2>>,
  TError,
  { organization: string; workspace: string; data: ApiHttpBodyBody },
  TContext
> => {
  const mutationOptions = getUploadFile2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Note: This is a gRPC-only endpoint (internal service-to-service call).
 * @summary Copy a file within the same organisation, returning a new file with a new file_name.
The copy is performed server-side (object-store copy); bytes never transit through the API.
Used internally by bishop-assets-api to implement DuplicateAsset / DuplicateFolder.
 */
export const copyFile = (
  v1CopyFileRequest: V1CopyFileRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CopyFileResponse>> => {
  return axios.default.post(
    `/bishop.files.v1.FilesService/CopyFile`,
    v1CopyFileRequest,
    options,
  );
};

export const getCopyFileMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyFile>>,
    TError,
    { data: V1CopyFileRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyFile>>,
  TError,
  { data: V1CopyFileRequest },
  TContext
> => {
  const mutationKey = ['copyFile'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyFile>>,
    { data: V1CopyFileRequest }
  > = props => {
    const { data } = props ?? {};

    return copyFile(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyFile>>
>;
export type CopyFileMutationBody = V1CopyFileRequest;
export type CopyFileMutationError = AxiosError<RpcStatus>;

/**
 * @summary Copy a file within the same organisation, returning a new file with a new file_name.
The copy is performed server-side (object-store copy); bytes never transit through the API.
Used internally by bishop-assets-api to implement DuplicateAsset / DuplicateFolder.
 */
export const useCopyFile = <TError = AxiosError<RpcStatus>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof copyFile>>,
      TError,
      { data: V1CopyFileRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof copyFile>>,
  TError,
  { data: V1CopyFileRequest },
  TContext
> => {
  const mutationOptions = getCopyFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * First response message contains metadata
Subsequent messages contain chunk_data

Note: This is a gRPC-only endpoint. HTTP clients should use
FilesHttpService.DownloadFile instead.
 * @summary Download file using gRPC streaming
Client requests file, server streams chunks back
 */
export const downloadFileStream = (
  v1DownloadFileStreamRequest: V1DownloadFileStreamRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DownloadFileStream200>> => {
  return axios.default.post(
    `/bishop.files.v1.FilesService/DownloadFileStream`,
    v1DownloadFileStreamRequest,
    options,
  );
};

export const getDownloadFileStreamMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadFileStream>>,
    TError,
    { data: V1DownloadFileStreamRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadFileStream>>,
  TError,
  { data: V1DownloadFileStreamRequest },
  TContext
> => {
  const mutationKey = ['downloadFileStream'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadFileStream>>,
    { data: V1DownloadFileStreamRequest }
  > = props => {
    const { data } = props ?? {};

    return downloadFileStream(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadFileStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadFileStream>>
>;
export type DownloadFileStreamMutationBody = V1DownloadFileStreamRequest;
export type DownloadFileStreamMutationError = AxiosError<RpcStatus>;

/**
 * @summary Download file using gRPC streaming
Client requests file, server streams chunks back
 */
export const useDownloadFileStream = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof downloadFileStream>>,
      TError,
      { data: V1DownloadFileStreamRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof downloadFileStream>>,
  TError,
  { data: V1DownloadFileStreamRequest },
  TContext
> => {
  const mutationOptions = getDownloadFileStreamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The lifetime of the file is the lifetime of the organization, ie,
if the organization is deleted, its file will also be deleted.

First message must contain metadata (parent, filename)
Subsequent messages contain chunk_data

Note: This is a gRPC-only endpoint. HTTP clients should use
FilesHttpService.UploadFile instead.
 * @summary Upload file using gRPC streaming
Client streams file chunks, server returns metadata when complete
 */
export const uploadFileStream = (
  v1UploadFileStreamRequest: V1UploadFileStreamRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UploadFileStreamResponse>> => {
  return axios.default.post(
    `/bishop.files.v1.FilesService/UploadFileStream`,
    v1UploadFileStreamRequest,
    options,
  );
};

export const getUploadFileStreamMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFileStream>>,
    TError,
    { data: V1UploadFileStreamRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFileStream>>,
  TError,
  { data: V1UploadFileStreamRequest },
  TContext
> => {
  const mutationKey = ['uploadFileStream'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFileStream>>,
    { data: V1UploadFileStreamRequest }
  > = props => {
    const { data } = props ?? {};

    return uploadFileStream(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFileStream>>
>;
export type UploadFileStreamMutationBody = V1UploadFileStreamRequest;
export type UploadFileStreamMutationError = AxiosError<RpcStatus>;

/**
 * @summary Upload file using gRPC streaming
Client streams file chunks, server returns metadata when complete
 */
export const useUploadFileStream = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFileStream>>,
      TError,
      { data: V1UploadFileStreamRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFileStream>>,
  TError,
  { data: V1UploadFileStreamRequest },
  TContext
> => {
  const mutationOptions = getUploadFileStreamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
